import type { LearningGrain } from '@/core/domain/learning/grain/LearningGrain.ts'
import type { ILearningGrainRepository } from '@/core/domain/learning/grain/ILearningGrainRepository.ts'
import { LearningStatus } from '@/core/domain/resources/enums/LearningStatus.ts'

export class UpdateLearningGrainStatusUseCase {
  private learningGrainRepository: ILearningGrainRepository

  constructor(learningGrainRepository: ILearningGrainRepository) {
    this.learningGrainRepository = learningGrainRepository
  }

  async execute(
    courseId: number,
    moduleId: number,
    grainId: number,
    status: LearningStatus.Values
  ): Promise<LearningGrain> {
    return this.learningGrainRepository.updateLearningGrainStatus(
      courseId,
      moduleId,
      grainId,
      status
    )
  }
}
